import { Channel, type UserInterface } from "@swivl-mono/types";

export function userPassesLocationFilter(
  user: UserInterface,
  allowedLocationsMap: { [id: string]: boolean },
  allowedGroupIds: Set<number>,
  hasOrgWideAccess: boolean
): boolean {
  if (user.locationId) return !!allowedLocationsMap[user.locationId];
  if (user.limitToGroupId) return hasOrgWideAccess || allowedGroupIds.has(user.limitToGroupId);
  if (user.lastUserMessageChannel === Channel.SMS) return true;
  return hasOrgWideAccess;
}
